import { useState } from "react";
import { faqData } from "@/mocks/homeData";

export default function FAQ() {
  const [openId, setOpenId] = useState<number | null>(null);

  const toggleFaq = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900">
            常见问题
          </h2>
          <p className="mt-3 text-foreground-600 text-base">
            快速了解必赢亚洲，解答您的疑问
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq) => (
            <div
              key={faq.id}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => toggleFaq(faq.id)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors duration-200"
              >
                <span className="text-sm font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <i
                  className={`flex-shrink-0 w-5 h-5 flex items-center justify-center text-foreground-500 transition-transform duration-300 ${
                    openId === faq.id ? "ri-subtract-line rotate-180" : "ri-add-line"
                  }`}
                ></i>
              </button>
              {openId === faq.id && (
                <div className="px-5 pb-4">
                  <div className="pt-1 border-t border-background-200">
                    <p className="text-sm text-foreground-600 leading-relaxed mt-3">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}